<template>
  <div
      class="mobi-main ui-page ui-page-theme-a ui-page-header-fixed ui-page-active"
      tabindex="0"
      data-role="page"
      id="page1"
  >
    <header
        data-role="header"
        data-position="fixed"
        role="banner"
        class="ui-header ui-bar-inherit ui-header-fixed slidedown"
    >
      <a
          href="javascript:void(0)"
          data-ajax="false"
          data-role="button"
          role="button"
          class="jqm-navmenu-link ui-btn-left ui-btn ui-icon-bars ui-btn-icon-notext ui-corner-all"
          @click.prevent="panelOpen = true"
      >
        菜单
      </a>
      <h1 role="heading" aria-level="1" class="ui-title">遊戲大廳</h1>
      <a
          href="javascript:void(0)"
          data-role="button"
          data-icon="delete"
          data-iconpos="notext"
          role="button"
          class="ui-link ui-btn-right ui-btn ui-icon-delete ui-btn-icon-notext ui-shadow ui-corner-all"
          aria-label="关闭"
          @click.prevent="onHeaderRight"
      ></a>
    </header>

    <div class="ui-panel-wrapper jm-wrap">
      <div data-role="content" role="main" class="pm ui-content jm-content">
        <div class="topBox">
          <div class="box">
            <a
                href="javascript:void(0)"
                class="ui-link"
                @click.prevent="handleTopLink('MobiCredit')"
            >
              <div class="ico1">
                <img :src="ico1" alt="" />
              </div>
              <div class="title">信用資料</div>
            </a>
          </div>
          <div class="box">
            <a
                href="javascript:void(0)"
                class="ui-link"
                @click.prevent="handleTopLink('MobiBetDetail')"
            >
              <div class="ico2">
                <img :src="ico2" alt="" />
              </div>
              <div class="title">下注明細</div>
            </a>
          </div>
          <div class="box">
            <a
                href="javascript:void(0)"
                class="ui-link"
                @click.prevent="goSettlement"
            >
              <div class="ico3">
                <img :src="ico3" alt="" />
              </div>
              <div class="title">結算報表</div>
            </a>
          </div>
        </div>

        <div class="mainBox">
          <ul v-if="lobbyLoaded">
            <a
                v-for="g in games"
                :key="g.id"
                href="javascript:void(0)"
                data-transition="slide"
                class="ui-link"
                role="button"
                tabindex="0"
                @click.prevent="onGame(g)"
                @keyup.enter.prevent="onGame(g)"
            >
              <li>
                <div class="pic3">
                  <img :src="g.icon" alt="" />
                </div>
                <div class="box">
                  <div class="title">{{ g.title }}</div>
                  <div class="main-box-desc" v-html="g.desc"></div>
                </div>
                <div class="arr"></div>
              </li>
            </a>
          </ul>
        </div>
      </div>
    </div>

    <div
        class="panel-mask"
        :class="{ 'is-open': panelOpen }"
        aria-hidden="true"
        @click="panelOpen = false"
    />

    <aside
        id="inside-a"
        data-role="panel"
        data-position="left"
        data-display="overlay"
        data-theme="b"
        class="ui-panel ui-panel-position-left ui-panel-display-overlay ui-body-b ui-panel-animate"
        :class="panelOpen ? 'ui-panel-open' : 'ui-panel-closed'"
        aria-label="侧栏菜单"
    >
      <div class="ui-panel-inner">
        <div class="panel-content">
          <div class="headBg">
            <img :src="headImg" alt="" />
            <div class="headBg__meta">
              <div v-if="drawerTitleSecondary" class="userName userName--sub">{{ drawerTitleSecondary }}</div>
            </div>
          </div>
          <ul>
            <a
                v-for="item in menuItems"
                :key="item.id"
                href="javascript:void(0)"
                data-transition="slide"
                class="ui-link"
                :class="{ 'ui-link--legacy-icon-out': item.iconOutsideLi }"
                @click.prevent="onMenuItem(item)"
            >
              <template v-if="item.iconOutsideLi">
                <span :class="item.iconClass"></span>
                <li>{{ item.label }}</li>
              </template>
              <template v-else>
                <li>
                  <span :class="item.iconClass"></span>{{ item.label }}
                </li>
              </template>
            </a>
          </ul>
        </div>
      </div>
    </aside>
  </div>
</template>

<script>
import '@/assets/css/Lobby.css'

import ico1 from '@/assets/images/Mobi/ico1.7f9b9b27.png'
import ico2 from '@/assets/images/Mobi/ico2.28dd7973.png'
import ico3 from '@/assets/images/Mobi/ico3.506d9304.png'
import headImg from '@/assets/images/Mobi/head.0e66193b.png'
import {memberInfo, memberLogout, memberLotterys, memberTrack} from '@/api/memberRestApi'
import { GAME_CODE_TO_LOTTERY, GAME_CODE_USE_CANONICAL_TITLE } from '@/api/memberLotteryIds'
import { useMemberRestEnv } from '@/api/memberGameMobi'
import mobiDrawerMemberProfile from '@/mixins/mobiDrawerMemberProfile'

const LS_USER = 'mobi_login_name'

function gameIcon(name) {
  return require(`@/assets/images/Mobi/${name}`)
}

const MOBI_GAME_DEFS = [
  { id: '1', code: 'ssc', title: '極速時時彩', icon: gameIcon('icon23.f23530a7.png'), desc: ' 每75秒一期，全天共1152期。 <br /> 上午07:00:30~次日06:59:15。 ' },
  { id: '2', code: 'lucky_airship', title: '幸運飛艇', icon: gameIcon('icon21.bf4f1f87.png'), desc: ' 每5分鐘一期，全天共180期。 <br /> 中午13:09~次日04:04。 ' },
  { id: '3', code: 'speed_car', title: '極速賽車', icon: gameIcon('icon22.4d650257.png'), desc: ' 每75秒一期，全天共1152期。 <br /> 上午07:00:33~次日06:59:18。 ' },
  { id: '4', code: 'speed_airship', title: '極速飛艇', icon: gameIcon('icon28.a9aa67bd.png'), desc: ' 每75秒一期，全天共1152期。 <br /> 上午07:01~次日06:59:45。 ' },
  { id: '5', code: 'aus5', title: '澳洲幸運5', icon: gameIcon('icon38.5e69cec0.png'), desc: ' 每5分鐘一期，全天共288期。 <br /> 上午07:04~次日06:59。 ' },
  { id: '6', code: 'aus10', title: '澳洲幸運10', icon: gameIcon('icon40.09cf597b.png'), desc: ' 每5分鐘一期，全天共288期。 <br /> 上午07:04~次日06:59。 ' },
  { id: '7', code: 'jsft', title: '極速番攤', icon: gameIcon('icon23.f23530a7.png'), desc: ' 快開番摊盤口：番、角、念、三门通正等。 ' },
  { id: 'jnd2', code: 'jnd2', title: '加拿大2.0', route: 'MobiCanada20', icon: gameIcon('jnd28.55f85e51.png'), desc: ' PC28 類快開，主勢盤、兩面、豹子/順子、龍虎和等玩法。 ' },
  { id: 'pc28dwp', code: 'pc28dwp', title: 'PC28大网盘', route: 'MobiCanada20', icon: gameIcon('pc28.s415wqsgh.png'), desc: ' 與加拿大2.0 一致：主勢盤、兩面、豹子/順子、龍虎和等玩法。 ' },
]

export default {
  name: 'MobiMain',
  mixins: [mobiDrawerMemberProfile],
  data() {
    return {
      panelOpen: false,
      ico1, ico2, ico3, headImg,
      games: [],
      lobbyLoaded: false,
      menuItems: [
        { id: 'm1', label: '信用資料', iconClass: 'iconL1', action: 'credit' },
        { id: 'm2', label: '下注明細', iconClass: 'iconL2', action: 'bet' },
        { id: 'm3', label: '結算報表', iconClass: 'iconL3', action: 'settlement' },
        { id: 'm4', label: '歷史開獎', iconClass: 'iconL4', action: 'drawHistory', iconOutsideLi: true },
        { id: 'm5', label: '玩法規則', iconClass: 'iconL5', action: 'playRules' },
        { id: 'm6', label: '修改密碼', iconClass: 'iconL6', action: 'changePassword' },
        { id: 'm7', label: '用戶協議', iconClass: 'iconL8', action: 'userAgreement' },
        { id: 'm8', label: '安全退出', iconClass: 'iconL9', action: 'logout' }
      ],
      memberInfo: null,
      pollTimer: null,
      hasNotified: false
    }
  },
  computed: {
    // 假设 g_lock 对应后端返回的 member.status
    isGLocked() {
      return this.memberInfo && (this.memberInfo.status == 1 || this.memberInfo.g_lock == 1)
    },
    // 强制退出标识
    isGOut() {
      return this.memberInfo && this.memberInfo.g_out == 1
    }
  },
  watch: {
    isGLocked(newVal) {
      if (newVal) this.handleLock();
    }
  },
  async mounted() {
    this.doMemberTrack();
    this.startPolling();
    if (!useMemberRestEnv()) {
      this.games = MOBI_GAME_DEFS.map((g) => Object.assign({}, g))
      this.lobbyLoaded = true
      return
    }
    try {
      const rows = await memberLotterys()
      console.log(rows);
      const arr = Array.isArray(rows) ? rows : []
      const byId = {}
      arr.forEach((r) => {
        const id = r.id != null ? r.id : r.lottery
        if (id != null) byId[String(id)] = (r.name || r.label || '').trim() || String(id)
      })
      this.games = MOBI_GAME_DEFS.filter((g) => {
        const lid = GAME_CODE_TO_LOTTERY[g.code]
        return !lid || byId[lid]
      }).map((g) => {
        const lid = GAME_CODE_TO_LOTTERY[g.code]
        const backend = lid && byId[lid]
        const title = GAME_CODE_USE_CANONICAL_TITLE.has(g.code) ? g.title : backend || g.title
        return Object.assign({}, g, {title})
      })
    } catch (e) {
      if (typeof console !== 'undefined' && console.warn) console.warn('[MobiMain] lotterys', e)
    }
    this.lobbyLoaded = true
  },
  beforeDestroy() {
    this.stopPolling();
  },
  created() {
    this.refreshDrawerMemberProfile()
  },
  methods: {
    startPolling() {
      if (this.pollTimer) return;
      this.pollTimer = setInterval(() => {
        this.refreshDrawerMemberProfile();
      }, 15000); // 15秒轮询一次
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async refreshDrawerMemberProfile() {
      if (!useMemberRestEnv()) return
      try {
        const lottery = GAME_CODE_TO_LOTTERY.ssc
        const raw = await memberInfo({lottery})
        this.memberInfo = raw && (raw.member || raw.user || raw)

    if (this.isGLocked) {
          try { localStorage.setItem('mobi_account_frozen', '1') } catch (e) { /* ignore */ }
          return
        }
      } catch (e) {
        if (typeof console !== 'undefined' && console.warn) console.warn('[MobiMain] memberInfo', e)
        if (e && e.response && e.response.status === 401) this.handleForceLogout('登入已過期');
      }
    },
    doMemberTrack() {
      memberTrack({ lastpage: '遊戲大廳' }).catch(() => {})
    },
    handleLock() {
      if (!this.hasNotified) {
        this.hasNotified = true;
      }
    },
    handleForceLogout(msg) {
      this.stopPolling();
      alert(msg || '您的帳號已在其他地方登入，請重新登入');
      this.$router.replace({name: 'Login'});
    },
    checkLock() {
      if (this.isGLocked) {
        this.handleLock();
        this.$router.push({name: 'MobiSettlement'});
        return true;
      }
      try {
        if (localStorage.getItem('mobi_account_frozen') === '1') {
          this.$router.push({name: 'MobiSettlement'});
          return true;
        }
      } catch (e) { /* ignore */ }
      return false;
    },
    onHeaderRight() {
      this.stopPolling();
      this.panelOpen = false
      try { localStorage.removeItem('mobi_account_frozen') } catch (e) { /* ignore */ }
      this.$router.replace({name: 'Login'})
    },
    handleTopLink(routeName) {
      const frozenAllowed = ['MobiCredit', 'MobiBetDetail', 'MobiSettlement', 'MobiDrawHistory', 'MobiPlayRules', 'MobiChangePassword', 'MobiUserAgreement']
      if (localStorage.getItem('mobi_account_frozen') === '1' && !frozenAllowed.includes(routeName)) {
        this.$router.push({name: 'MobiSettlement'})
        return
      }
      this.$router.push({name: routeName})
    },
    goSettlement() {
      this.$router.push({name: 'MobiSettlement'})
    },
    onGame(g) {
      if (this.checkLock()) return
      const routeName = g.route || 'MobiGamePlay';
      this.$router.push({
        name: routeName,
        query: {...this.$route.query, lottery: g.title, id: g.id}
      })
    },
    onMenuItem(item) {
      const frozenAllowedActions = ['credit', 'bet', 'settlement', 'drawHistory', 'playRules', 'changePassword', 'userAgreement', 'logout']
      if (localStorage.getItem('mobi_account_frozen') === '1' && !frozenAllowedActions.includes(item.action)) {
        this.panelOpen = false
        return
      }

      if (item.action === 'logout') {
        this.stopPolling();
        try {
          memberLogout()
          localStorage.removeItem(LS_USER)
          localStorage.removeItem('mobi_account_frozen')
        } catch (e) {
        }
        this.panelOpen = false
        this.$router.replace({name: 'Login'})
        return
      }

      const routeMap = {
        credit: 'MobiCredit',
        bet: 'MobiBetDetail',
        settlement: 'MobiSettlement',
        drawHistory: 'MobiDrawHistory',
        playRules: 'MobiPlayRules',
        changePassword: 'MobiChangePassword',
        userAgreement: 'MobiUserAgreement'
      };

      if (routeMap[item.action]) {
        this.panelOpen = false;
        this.$router.push({
          name: routeMap[item.action],
          query: item.action === 'settlement' ? {} : {...this.$route.query}
        });
      }
    }
  }
}
</script>
